<template>
  <div>
    <div class="container">
      <h2  class="mt-3">Gallery</h2>
      <h2 />
      <div class="gallery-wrapper row mt-3 mx-auto">
        <gallery
        class="gallery-wrapper-image"
          :images="images"
          :index="index"
          @close="index = null"
        ></gallery>
        <div
          class="image gallery-wrapper-image"
          v-for="(image, imageIndex) in images"
          :key="imageIndex"
          @click="index = imageIndex"
          :style="{
            backgroundImage: 'url(' + image + ')',
            width: '350px',
            height: '220px'
          }"
        >
          <div></div>
        </div>
      </div>
      <InfiniteScrollTrigger @refresh="onRefresh" v-if="loaded"/>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import VueGallery from "vue-gallery";
import InfiniteScrollTrigger from '@/components/shared/InfiniteScrollTrigger.vue';
export default {
  data() {
    return {
      index: null,
      loaded: false
    };
  },
  components: {
    gallery: VueGallery,
    Footer,
    InfiniteScrollTrigger
  },
  created() {
    this.$store.dispatch('loadGallery');
  },
  mounted() {
    setTimeout(() =>{
      this.loaded = true;
    }, 2500);
  },
  methods: {
    onRefresh() {
      this.$store.dispatch('loadMoreGallery');
    }
  },
  computed :{
    images() {
      return this.$store.getters.getGallery;
    }
  }
};
</script>

<style scoped>
.image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #b9b6b6;
}
.gallery-wrapper {
  display: flex;
  justify-content: center;
}
@media (min-width: 359px) and (max-width: 992px) { 
  .gallery-wrapper-image {
    margin-bottom: 10px;
  }
}
 
</style>